import { of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { navigateCrossPlatform } from 'src/app/util';
import * as i0 from "@angular/core";
import * as i1 from "./template.service";
import * as i2 from "../../cms-generator/service/cms.service";
import * as i3 from "@angular/router";
import * as i4 from "../../../share/service/server-config.service";
import * as i5 from "@nguniversal/express-engine/tokens";
export class CmsModuleResolverService {
    constructor(templateService, cmsService, router, serverConfigService, response) {
        this.templateService = templateService;
        this.cmsService = cmsService;
        this.router = router;
        this.serverConfigService = serverConfigService;
        this.response = response;
        this.toHomePath = `/${serverConfigService.config.lang}`;
    }
    resolve(route, state) {
        const cmsType = route.params['cmsType'];
        return this.cmsService.resolveCmsType(this.templateService.lang, cmsType).pipe(catchError(error => {
            if (this.serverConfigService.isBrowser) {
                navigateCrossPlatform(this.serverConfigService.isBrowser, this.router, this.response, [`${this.toHomePath}/404`]);
                return throwError(error);
            }
            else {
                this.response.status(500);
                return of(undefined);
            }
        }));
    }
}
CmsModuleResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CmsModuleResolverService_Factory() { return new CmsModuleResolverService(i0.ɵɵinject(i1.TemplateService), i0.ɵɵinject(i2.CmsService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.ServerConfigService), i0.ɵɵinject(i5.RESPONSE, 8)); }, token: CmsModuleResolverService, providedIn: "root" });
